export const formLabelTheme = {
  baseStyle: {
    fontSize: 'sm'
  }
}
